var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "footer" }, [
      _c("div", { staticClass: "banxin" }, [
        _c("div", { staticClass: "center" }, [
          _c(
            "div",
            { staticClass: "help-container" },
            _vm._l(_vm.center.help, function(item, index) {
              return _c(
                "div",
                { key: index },
                [
                  _c("div", [_vm._v(_vm._s(item.title))]),
                  _vm._v(" "),
                  _vm._l(item.content, function(item2) {
                    return _c(
                      "router-link",
                      {
                        key: item2.name,
                        attrs: {
                          to: {
                            path: "/helpCenter",
                            query: { categoryId: item2.url }
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(item2.name) +
                            "\n            "
                        )
                      ]
                    )
                  })
                ],
                2
              )
            }),
            0
          ),
          _vm._v(" "),
          _c("span", { staticClass: "line" }),
          _vm._v(" "),
          _c("div", { staticClass: "phone-container" }, [
            _c("div", [_vm._v(_vm._s(_vm.center.phone.number))]),
            _vm._v(" "),
            _c("div", [_vm._v(_vm._s(_vm.center.phone.title))]),
            _vm._v(" "),
            _vm._m(0)
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "line" }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "QR-container" },
            _vm._l(_vm.center.QR_code, function(item, index) {
              return _c("div", { key: index }, [
                _c("img", { attrs: { src: item.code, alt: "" } }),
                _vm._v(" "),
                _c("div", [
                  _c("img", { attrs: { src: item.icon, alt: "" } }),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(item.text))])
                ])
              ])
            }),
            0
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "bottom" }, [
      _c("div", { staticClass: "bottom-content" }, [
        _c(
          "div",
          { staticClass: "go-another" },
          [
            _vm._l(_vm.bottom.content, function(item, index) {
              return [
                _c("a", { key: item.i, attrs: { href: item.url } }, [
                  _vm._v(_vm._s(item.name))
                ]),
                _vm._v(" "),
                index !== _vm.bottom.content.length - 1
                  ? _c("span", { key: index })
                  : _vm._e()
              ]
            })
          ],
          2
        ),
        _vm._v(" "),
        _c("div", [_vm._v(_vm._s(_vm.bottom.text))])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _c("i", { staticClass: "el-icon-phone" }),
      _vm._v("\n            联系客服\n          ")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-26a9f6a5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-26a9f6a5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/base_b2c/footer.vue
// module id = null
// module chunks = 